module.exports = __webpack_public_path__ + "static/media/comments.ba4eec3d.png";